import React, { createRef, HTMLInputAutoCompleteAttribute } from "react";
import { IBaseComponentProps, IValidationProps, IValidationStringProps, INSBoxBaseLayoutProps, INSBox, NSBoxPassword, safeMenuMenuItem } from "namirasoft-site-react";
import { NamirasoftSecretMetaDatabase, NamirasoftSecretServer } from "namirasoft-secret";
import { BaseUUID, EnvService } from "namirasoft-core";
import { NSARouterMakerProps } from "../NSARouterMakerProps";

export interface NSBoxSecretProps extends IBaseComponentProps, IValidationProps, IValidationStringProps, NSARouterMakerProps, INSBoxBaseLayoutProps<NSBoxSecret, string>
{
	input?: IBaseComponentProps;
	auto_complete?: HTMLInputAutoCompleteAttribute | undefined;
}

interface NSBoxSecretState 
{
	secret_id: string | null;
	value: string | null;
}

export class NSBoxSecret extends React.Component<NSBoxSecretProps, NSBoxSecretState> implements INSBox
{
	private NSBoxPassword_Main = createRef<NSBoxPassword>();
	constructor(props: NSBoxSecretProps)
	{
		super(props);
		this.state = { secret_id: null, value: null };
		this.isEmpty = this.isEmpty.bind(this);
		this.getError = this.getError.bind(this);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
	}
	isEmpty(value: string)
	{
		return this.NSBoxPassword_Main.current?.isEmpty(value) ?? true;
	}
	getError(): string | null
	{
		if (this.state.secret_id && !this.state.value)
			return null;
		return this.NSBoxPassword_Main.current?.getError() ?? null;
	}
	getValue(checkError: boolean = true): string | null
	{
		if (this.state.secret_id && !this.state.value)
			return "";
		return this.NSBoxPassword_Main.current?.getValue(checkError) ?? null;
	}
	setValue(value: string | null, callback?: () => void): void
	{
		let meta = new NamirasoftSecretMetaDatabase();
		let short = meta.tables.secret.uuid.short;
		if (BaseUUID.isValidShort(value ?? "", short))
			this.setState({ secret_id: value, value: null });
		else
		{
			this.setState({ secret_id: null, value });
			this.NSBoxPassword_Main.current?.setValue(value, callback);
		}
	}
	override render()
	{
		let input_style: React.CSSProperties = {};
		let placeholder = undefined;
		if (this.state.secret_id && !this.state.value)
		{
			input_style.backgroundColor = "#00000030";
			input_style.textAlign = "center";
			placeholder = this.state.secret_id;
		}

		let menu = safeMenuMenuItem(this.props, (items) =>
		{
			if (this.state.secret_id && !this.state.value)
				items.push({
					title: "Load From Secret",
					icon: "https://static.namirasoft.com/image/namirasoft/secret/logo/base.png",
					onClick: () =>
					{
						let REACT_APP_BASE_URL_SECRET = new EnvService("REACT_APP_BASE_URL_SECRET", true).getString();
						let server = new NamirasoftSecretServer(REACT_APP_BASE_URL_SECRET, this.props.account.token_manager, this.props.notifier.onError);
						if (this.state.secret_id)
							server.secret.GetValue(this.state.secret_id).then(value =>
							{
								this.NSBoxPassword_Main.current?.setValue(value);
							}).catch(() => { });
					}
				});
		});

		return (
			<>
				<NSBoxPassword
					ref={this.NSBoxPassword_Main}
					{...this.props}
					onChanged={(box) =>
					{
						this.setState({ value: box.getValue(false) });
						this.props.onChanged?.(this);
					}}
					onClicked={() => this.props.onClicked?.(this)}
					placeholder={placeholder}
					input={{ style: input_style }}
					menu={menu}
				/>
			</>
		);
	}
}